<template>
	<v-card class="opaquerBg" rounded>
		<v-card-text>
			<h2 class="text-h4 font-weight-light">Latest headlines</h2>
			<v-row no-gutters>
				<v-col
					cols="11"
					v-for="(item, index) in news.slice().reverse()"
					:key="index"
				>
					<NewsItem @click='showDialog(item)' v-bind="item" v-if='item.type == "LOCAL"' />
					<NewsItemLink v-bind="item" v-else />
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import NewsItem from './n-items/NewsItem'
import NewsItemLink from './n-items/NewsItemLink'

import NewsDialog from '@/components/dialogs/NewsDialog'

export default {
	name: 'NewsList',
	props: {
		news: Array,
	},
	components: {
		NewsItem,
		NewsItemLink,
		NewsDialog
	},
	methods: {
		showDialog(item) {
			this.$dialog.show(NewsDialog, { item, width: 800  })
		}
	},
}
</script>